export default __webpack_public_path__ + "static/media/04-Munther-AlBlooshi.6bae5e40.png";